<template>
  <div id="introduce-guideline">
    <section ref="Giới Thiệu" id="Giới Thiệu">
      <h4>Interactive Ecommerce</h4>
      <div class="content-introduce">
        <p>
          <b>Interactive Ecommerce</b>
          là phần dành riêng cho hệ thống AI Ecommerce Vieon. <br />
          Tất cả những sản phẩm,nhãn hiệu,sẽ được bộ phận content biên tập, chọn
          lọc để tạo ra tập data dành cho <b>Admin Tool AI Indexing</b>
          <img
            class="pa-2 rounded-lg"
            src="../../assets/tutorial/ai-editor/indexingecommerce.png"
          />
          Để tạo được folder chưa toàn bộ nội dung đã biên soạn,chúng ta sẽ đến
          với phần tiếp theo
        </p>
      </div>
    </section>
    <v-divider></v-divider>
    <section
      ref="Hướng Dẫn Create Folder Interactive Ecommerce"
      id="Hướng Dẫn Create Folder Interactive Ecommerce"
    >
      <h4>Hướng Dẫn Create Folder Interactive Ecommerce</h4>
      <img src="../../assets/tutorial/ai-editor/timelinechart.png" />
      <div>
        <p>
          Ở trong phần timeline đã được hướng dẫn ở phần
          <router-link to="/document/timelinechart">
            <div class="sub-title">Timeline Chart</div></router-link
          >
        </p>
        <p>
          Sau khi người dùng đã tương tác với timeline chart,và tạo ra được các
          segment,box đúng với mong muốn
        </p>
        <p>
          <img
            class="rounded-lg"
            width="40"
            src="../../assets/tutorial/ai-editor/save-as-data.png"
          />Người chọn button Save As New,hoặc bấm tổ hợp phím
          <b>Ctrl + Shift + S</b>
        </p>
        <p>Sau đó sẽ có dialog create new xuất hiện</p>
        <p>
          Phần này người dùng có thể chọn new folder mới hoàn toàn,hoặc có thể
          save as đè lên folder đã tồn tại
        </p>
        <img
          class="rounded-lg"
          src="../../assets/tutorial/ai-editor/dialog-save-as-new.png"
        />
      </div>
      Sau khi save thành công,người dùng quay lại màn hình danh sách
      products&brand sẽ thấy được folder mới tạo,folder này sẽ được liên kết
      thẳng đến
      <b>Admin Tool AI Indexing</b>
    </section>
  </div>
</template>

<script>
import { call, sync } from "vuex-pathify";
import { mdiChatAlert } from "@mdi/js";
export default {
  data() {
    return {
      mdiChatAlert: mdiChatAlert,
      currentSectionId: "",
    };
  },

  mounted() {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 1,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.myAnchorTilte = entry.target.id;
        }
      });
    }, options);

    Object.values(this.$refs).forEach((ref) => observer.observe(ref));

    let items = document.getElementById("introduce-guideline")?.childNodes;
    if (items) {
      let ids = Array.prototype.reduce.call(
        items,
        function (arr, elem) {
          arr.push(elem.id);
          return arr;
        },
        []
      );
      this.setListTitle([...ids]);
    }
  },
  beforeDestroy() {
    localStorage.removeItem("myAnchorTilte");
    this.setListTitle([]);
    window.scrollTo(0, 2);
  },
  computed: {
    myAnchorTilte: sync("showcase/myAnchorTilte"),
  },
  methods: {
    setListTitle: call("showcase/setListTitle"),
  },
};
</script>

<style lang="scss">
#Introduce {
  ul.circle {
    list-style-type: circle;
  }
  .content-introduce {
    padding: 10px;
    background-color: #f9f9f9;
  }
}
</style>
